import { Component } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { HorizontalSplitterComponent } from '@module-definition/horizontal-splitter/horizontal-splitter.component';

import { CipoFormModule } from '@shared/modules';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-demo-angular-input',
  templateUrl: './demo-angular-input.component.html',
  styleUrls: ['./demo-angular-input.component.scss'],
  imports: [CipoFormModule, HorizontalSplitterComponent],
})
export class DemoAngularInputComponent {
  clearValue = 'Clear me';

  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  matcher = new MyErrorStateMatcher();
}
